// components/pergola/InstallationWalls.tsx
import { Edges, useTexture } from "@react-three/drei";
import React, { useMemo } from "react";
import { InstallationType } from "../../forms/Pergola_type";
import { ElementCoordinateSystem } from "../common_types";
import { ConditionalAxesHelper, sezionePilastro } from "../Pergola";
import { computeOrientation } from "../transformations";
import * as THREE from "three";


interface InstallationWallsProps {
  installazione: InstallationType;
  larghezzaSoletta: number;
  lunghezzaSoletta: number;
  isLatoLibero: (direzione: "Fronte" | "Retro" | "Destra" | "Sinistra") => boolean;
  altezzaMuro: number;
}
export const Muro: React.FC<{
  larghezza: number;
  lunghezza: number;
  altezza: number;
  cs: ElementCoordinateSystem;
}> = (props) => {
  const rotation = useMemo(
    () => computeOrientation(props.cs.direction),
    [props.cs.direction]
  );
  const coloreMuro = "#d9d9d9";

  return (
    <mesh
      position={[props.cs.org.x, props.cs.org.y, props.cs.org.z]}
      rotation={[rotation[0], rotation[1], rotation[2]]}
    >
      <boxGeometry args={[props.larghezza, props.lunghezza, props.altezza]} />
      <meshStandardMaterial
        color={coloreMuro}
        roughness={0.9}
        metalness={0.05}
      />
      <Edges color="#888888" />
      <ConditionalAxesHelper />
    </mesh>
  );
};
const InstallationWalls: React.FC<InstallationWallsProps> = ({
  installazione,
  larghezzaSoletta,
  lunghezzaSoletta,
  altezzaMuro,
  isLatoLibero,
}) => {
  return (
    <group>
      
      {/* Muro laterale sinistro (H1-H2) */}
      {(!isLatoLibero("Retro")) && (
        <Muro
          larghezza={larghezzaSoletta}
          lunghezza={0.2}
          altezza={altezzaMuro}
          cs={{
            org: {
              x: 0,
              y: lunghezzaSoletta / 2 + 0.1,
              z: altezzaMuro / 2,
            },
            direction: [0, 0, 1],
          }}
        />
        )
      }
      {/* Muro laterale sinistro (H4-H3) */}
      {(!isLatoLibero("Fronte")) && (
        <Muro
            larghezza={larghezzaSoletta}
            lunghezza={0.2}
            altezza={altezzaMuro}
            cs={{
              org: {
                x: 0,
                y: -lunghezzaSoletta / 2 - 0.1,
                z: altezzaMuro / 2,
              },
              direction: [0, 0, 0],
            }}
          />
        )
      }
      {(!isLatoLibero("Sinistra")) && (
          <Muro
            larghezza={0.2}
            lunghezza={lunghezzaSoletta}
            altezza={altezzaMuro}
            cs={{
              org: {
                x: -larghezzaSoletta / 2 - 0.1,
                y: 0,
                z: altezzaMuro / 2,
              },
              direction: [0, 0, 0],
            }}
          />
        )
      }
      {(!isLatoLibero("Destra")) && (
          <Muro
            larghezza={0.2}
            lunghezza={lunghezzaSoletta}
            altezza={altezzaMuro}
            cs={{
              org: {
                x: larghezzaSoletta / 2 + 0.1,
                y: 0,
                z: altezzaMuro / 2,
              },
              direction: [0, 0, 0],
            }}
          />
        )
      }
    </group>
  );
};

export default InstallationWalls;